import React from 'react';
import Portabletext from 'components/PortableText';
import { CompanyDetailPageContent as ICompanyDetailPageContent } from 'lib/cms/types';

interface Props {
  content: ICompanyDetailPageContent;
}

const CompanyDetailPageContent: React.FC<Props> = ({ content }) => {
  return (
    <div className="CompanyDetailPageContent__body mxauto pt4 md:pt0">
      <Portabletext blocks={content.body} />
    </div>
  );
};

export default CompanyDetailPageContent;
